import { Component } from '@angular/core';
import { ModalService } from '@src/shared/modal/modal.service';
import { RoutingService } from '../../woo_services.module/RoutingService';
import { User } from '../../woo_services.module/shared-types';

@Component({
  selector: 'new-user',
  template: `
    <div class="inner-block">
      <div class="account__card inner-block block clearfix shadow-z-1">
        <div class="col-12">
          <h2>Ny WOO-användare</h2>
          <br />
          <user-form (afterSubmit)="afterSubmit($event)" (onAbort)="goBack()"></user-form>
        </div>
      </div>
    </div>
  `,
  standalone: false,
})
export class NewUser {
  constructor(private routingService: RoutingService, private modalService: ModalService) {}

  afterSubmit(user: User): void {
    this.routingService.navigate(['/user', user.id]);
    const msg = `En användare för ${user.first_name} ${user.last_name} har nu skapats och ett mail med instruktioner för att sätta lösenord har skickats till ${user.email}.`;
    this.modalService.openSuccess(msg);
  }

  goBack(): void {
    this.routingService.navigate(['/accounts']);
  }
}
